// extracted by mini-css-extract-plugin
export default {"authPageContainer":"_Tc7imLA","authCard":"nKe0yMK8","authForm":"tLN8vPlo","title":"grYsyifr","description":"n2V25fLQ","errorAlert":"Rni50Ioi"};